import { IconShare3 } from "@tabler/icons-react";
import { Button } from "@altimateai/lego";
import { FC, useCallback, useState } from "react";
import { EmailDialog } from "../emailDialog/EmailDialog";
import { ApiHelper } from "../../../api/index";

interface ShareMessageProps {
  sessionId?: string;
}

export const ShareMessage: FC<ShareMessageProps> = ({ sessionId }) => {
  const [showEmailDialog, setShowEmailDialog] = useState(false);
  const [isEmailing, setIsEmailing] = useState(false);

  const handleSendEmail = useCallback(
    async (emails: string[]) => {
      if (!sessionId) {
        throw new Error("No session available for email");
      }

      setIsEmailing(true);
      try {
        const payload = {
          session_id: sessionId,
          emails: emails,
        };

        await ApiHelper.post<{ success: boolean }>("studio/session_to_email_mailing_list", payload);

        // Success - dialog will close automatically
      } catch (error) {
        console.error("Failed to send email:", error);
        throw error; // Re-throw to let dialog handle error display
      } finally {
        setIsEmailing(false);
      }
    },
    [sessionId]
  );

  return (
    <>
      <Button
        variant="outline"
        className={"al-bg-transparent al-text-gray-500"}
        size="sm"
        onClick={() => setShowEmailDialog(true)}
        disabled={!sessionId}
        aria-label="Email response"
      >
        <IconShare3 aria-hidden="true" />
        Share
      </Button>
      <EmailDialog
        open={showEmailDialog}
        onClose={() => setShowEmailDialog(false)}
        onSendEmail={handleSendEmail}
        isLoading={isEmailing}
      />
    </>
  );
};
